import { createContext, useContext } from 'react';
import { useSessionModalsControl } from '../model/hooks/useSessionModalsControl';
import { useSpringModal } from '../model/hooks/useSpringModal';
import { useAppState, useOnboarding } from '../../../redux/reducer/content';
import { ServiceDataKeys } from '../constants/serviceData';
import { CUSTOMIZATION } from '../../../constants/shared/states/names';

/**
 * @description Провайдер для контроля модальных окон с проверкой на сессию
 *
 * Описание флагов
 * - key - ключ в сервисных данных
 * - isAvailable - готовы ли все данные для того, чтобы проверить возможность показа окна
 * - isTruthState - подходит ли стейт
 * - isCanShow - может ли модальное окно быть показано
 * - set - функция, сохраняющая результат показа (или не показа)
 */

const ExtraModalsContext = createContext({});

export const useExtraModalContext = () => useContext(ExtraModalsContext);

export function ExtraModalsProvider({ children }) {
  const state = useAppState();
  const { premiumModalsVisible } = useOnboarding();

  const { modalsData, set } = useSessionModalsControl();

  //TODO: вынести логику проверки в одну функцию

  useSpringModal({
    key: ServiceDataKeys.SPRING_MODAL,
    isAvailable: premiumModalsVisible,
    isTruthState: state === CUSTOMIZATION,
    isCanShow: !modalsData[ServiceDataKeys.SPRING_MODAL],
    set,
  });

  return <ExtraModalsContext.Provider value={{}}>{children}</ExtraModalsContext.Provider>;
}
